import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const PromoScrollTop = () => (
  <>
    <a
      href="#"
      className="scrollTop"
      onClick={(event) => {
        event.preventDefault();
        window.scrollTo(0, 0);
      }}
    ></a>

    <style jsx>{`
      .scrollTop {
        display: block;
        z-index: 2;
        position: fixed;
        cursor: pointer;
        bottom: 30px;
        left: 5%;
        height: 44px;
        width: 44px;
        overflow: hidden;
        border-radius: ${isBricoStore ? "50%" : "3px"};
        background-color: rgba(255, 255, 255, 0.9);
        -webkit-box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);
      }

      .scrollTop:after {
        content: "";
        display: inline-block;
        margin-top: 18px;
        margin-left: 13px;
        width: 18px;
        height: 18px;
        border-top: 3px solid #333;
        border-right: 3px solid #333;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
      }

      .scrollTop:hover:after {
        border-color: ${isBricoStore ? "#da281a" : "#d71440"};
      }
    `}</style>
  </>
);

export default PromoScrollTop;
